import { jsx as _jsx } from "react/jsx-runtime";
import { useId } from "@radix-ui/react-id";
import { useControllableState } from "@radix-ui/react-use-controllable-state";
import { memo, useCallback, useRef } from "react";
import { PANEL_NAME, PanelProvider } from "~/components/v2/components/shared/panel/PanelProvider";
export const Panel = /*#__PURE__*/ memo((param)=>{
    let { __scopePanel, children, defaultOpen, open: openProp, onOpenChange } = param;
    const contentRef = useRef(null);
    const triggerRef = useRef(null);
    const [open, setOpen] = useControllableState({
        prop: openProp,
        defaultProp: defaultOpen !== null && defaultOpen !== void 0 ? defaultOpen : false,
        onChange: onOpenChange,
        caller: PANEL_NAME
    });
    const onOpenClose = useCallback(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const onOpenToggle = useCallback(()=>{
        setOpen((prev)=>!prev);
    }, [
        setOpen
    ]);
    return /*#__PURE__*/ _jsx(PanelProvider, {
        contentId: useId(),
        contentRef: contentRef,
        onOpenChange: setOpen,
        onOpenClose: onOpenClose,
        onOpenToggle: onOpenToggle,
        open: open,
        scope: __scopePanel,
        triggerRef: triggerRef,
        children: children
    });
});
Panel.displayName = "Panel";
